import { useCallback, useEffect, useState } from 'react';

// import "./styles.css";

// material-ui
import { Box, Tab, Tabs, Toolbar, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { useRecoilValue } from 'recoil';

import { UserType } from '../../../../types/types';
import { userAtom } from '../../../../atoms/atoms';
import findAllData from '../../../../resources/Api/dashboard/findAllData';
import { useCookies } from 'react-cookie';
import TotalItemCard from '../../../privateManagerApp/home/dashboard/TotalItemCard';
import { DashboardOutlined, GpsFixedOutlined, HailOutlined, SupportAgentOutlined } from '@mui/icons-material';
import { MapContainer, Marker, TileLayer } from 'react-leaflet';
import L from "leaflet";
import TotalGrowthBarChart from './TotalGrowthBarChart';
import TotalDonutChart from '../../../privateManagerApp/home/dashboard/TotalDonutChart';
import TrackingTab from '../../../privateManagerApp/home/dashboard/TrackingTab';

const CustomerDashboard = () => {
    const getCurrentUser = useRecoilValue<UserType>(userAtom);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const chartGridSx = {
        display: 'grid',
        gridTemplateColumns: { xs: 'minmax(0, 1fr)', md: 'repeat(2, minmax(0, 1fr))', lg: 'repeat(3, minmax(0, 1fr))' },
        gap: 1.5,
        width: '100%',
    };

    const twoChartGridSx = {
        ...chartGridSx,
        gridTemplateColumns: { xs: 'minmax(0, 1fr)', lg: 'repeat(2, minmax(0, 1fr))' },
    };
    const [activeTab, setActiveTab] = useState(0);

    const [isLoading, setLoading] = useState(false);
    const [totalDriverCount, setTotalDriverCount] = useState<Array<number>>([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);
    const [totalVehiclesCount, setTotalVehiclesCount] = useState<Array<number>>([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);
    const [totalTicketsResolved, setTotalTicketsResolved] = useState<number>(0);
    const [totalTicketsUnresolved, setTotalTicketsUnresolved] = useState<number>(0);
    const [totalDriversPerCnh, setTotalDriversPerCnh] = useState<Array<{}>>([{}]);
    const [totalVehiclesPerBrand, setTotalVehiclesPerBrand] = useState<Array<{}>>([{}]);
    const [totalTicketsByGravity, setTotalTicketsByGravity] = useState<Array<{}>>([{}]);

    const [totalVehiclesPositions, setTotalVehiclesPositions] = useState<Array<any>>([{}]);
    const [totalDevicesByManufacturer, setTotalDevicesByManufacturer] = useState<Array<{}>>([{}]);
    const [totalVehiclesByStatus, setTotalVehiclesByStatus] = useState<Array<{}>>([{}]);

    // cookies
    const [cookies] = useCookies(["selectedParameters", "token"]);

    const getDashboardData = useCallback(
        async (status: string = "activated") => {
            const token: string = cookies.token || sessionStorage.getItem("token");
            setLoading(true);
            try {
                const { data } = await findAllData(token, getCurrentUser.customer?.managerId!!, getCurrentUser.customer.id);
                setTotalDriverCount(data.totalDriverCount);
                setTotalVehiclesCount(data.totalVehiclesCount);
                setTotalTicketsResolved(data.totalTicketsResolved);
                setTotalTicketsUnresolved(data.totalTicketsUnresolved);
                setTotalDriversPerCnh(data.totalDriversPerCnh);
                setTotalVehiclesPerBrand(data.totalVehiclesPerBrand);
                setTotalTicketsByGravity(data.totalTicketsByGravity);
                setTotalDevicesByManufacturer(data.totalDevicesByManufacturer);
                setTotalVehiclesByStatus(data.totalVehiclesByStatus);
                setTotalVehiclesPositions(data.totalVehiclePositions);

            } catch (error: any) {
                console.log(error);
                setTotalDriverCount([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);
                setTotalVehiclesCount([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);
                setTotalTicketsResolved(0);
                setTotalTicketsUnresolved(0);
                setTotalDriversPerCnh([{}]);
                setTotalVehiclesPerBrand([{}]);
                setTotalTicketsByGravity([{}]);
                setTotalVehiclesPositions([{}]);
            } finally {
                setTimeout(() => {
                    setLoading(false);
                }, 2000);
            }
        },
        [cookies.token, getCurrentUser.customer.id, getCurrentUser.customer?.managerId]
    );

    useEffect(() => {
        getDashboardData();
    }, [getDashboardData]);

    return (
        <Box
            className="dashboard-root grid-box-out-container container item tw-w-full tw-min-w-0 tw-bg-slate-50 tw-p-2 dark:tw-bg-slate-950 sm:tw-p-3"
            style={{
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                padding: 8,
                background: "#f9fafb",
            }}
        >
            <>
                <Toolbar
                    className="grid-header-bar tw-mb-3 tw-rounded-xl tw-bg-gtr-sidebar tw-text-white tw-shadow-sm"
                    style={{
                        display: "grid",
                        backgroundImage: "linear-gradient(to right, #09414A , #09414A)",
                        fontFamily: "Prometo",
                        borderRadius: 12,
                        marginBottom: 12,
                        color: "#ffff",
                    }}
                >
                    <Box
                        className="header-actions tw-min-w-0"
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            alignContent: "center",
                            fontFamily: "Prometo",
                        }}
                    >
                        <Typography variant="body1" sx={{ fontWeight: 700, fontFamily: "Prometo", overflowWrap: 'anywhere' }}>
                            Bem vindo de volta, {getCurrentUser.name}!
                        </Typography>
                    </Box>
                </Toolbar>

                <Toolbar
                    className="grid-header-bar tw-mb-3 tw-overflow-hidden tw-rounded-xl tw-bg-gtr-sidebar tw-text-white tw-shadow-sm"
                    sx={{
                        display: "flex",
                        backgroundImage: "linear-gradient(to right, #09414A , #09414A)",
                        fontFamily: "Prometo",
                        minHeight: 48,
                        borderRadius: 3,
                        mb: 1.5,
                        color: "#fff",
                        px: 1,
                    }}
                >
                    <Box className="header-actions" sx={{ display: "flex", alignItems: "center", overflowX: "auto", width: "100%" }}>
                        <Tabs
                            value={activeTab}
                            onChange={(_event, value) => setActiveTab(value)}
                            variant={isMobile ? "scrollable" : "fullWidth"}
                            scrollButtons={isMobile ? "auto" : false}
                            allowScrollButtonsMobile
                            indicatorColor="primary"
                            textColor="inherit"
                            sx={{
                                fontFamily: "Prometo",
                                color: "#fff",
                                width: "100%",
                                minHeight: 48,
                                "& .MuiTabs-indicator": { height: 3, borderRadius: 3, backgroundColor: "#00B700" },
                                "& .MuiTab-root": {
                                    minHeight: 48,
                                    border: "none",
                                    borderRadius: 2,
                                    fontFamily: "Prometo",
                                    fontSize: 14,
                                    fontWeight: 600,
                                    textTransform: "none",
                                    color: "rgba(255,255,255,0.72)",
                                },
                                "& .MuiTab-root:hover": { backgroundColor: "rgba(255,255,255,0.08)", color: "#fff" },
                                "& .Mui-selected": { color: "#fff !important", backgroundColor: "rgba(255,255,255,0.08)" },
                            }}
                        >
                            <Tab icon={<DashboardOutlined />} aria-label="system-tab" label={isMobile ? "" : "Visão geral"} />
                            <Tab icon={<GpsFixedOutlined />} aria-label="tracking-tab" label={isMobile ? "" : "Operacional"} />
                        </Tabs>
                    </Box>
                </Toolbar>

                {activeTab === 0 ? <Box className="tw-flex tw-w-full tw-min-w-0 tw-flex-col tw-gap-3 tw-px-2 tw-pb-4 sm:tw-px-3">
                    <Box className="tw-grid tw-min-w-0 tw-grid-cols-1 tw-gap-3 lg:tw-grid-cols-[minmax(0,7fr)_minmax(0,5fr)]">
                        <Box className="tw-flex tw-min-w-0 tw-flex-col">
                        <Box className="tw-min-w-0 tw-flex-1">
                            <TotalGrowthBarChart
                                isLoading={false}
                                dataCharDriverList={totalDriverCount}
                                dataChartVehiclesList={totalVehiclesCount}
                            />
                        </Box>
                        </Box>
                    {/*-----------------------*/}

                    <Box className="tw-flex tw-min-w-0 tw-flex-col tw-gap-3">
                            <Box className="tw-min-w-0 tw-text-center" sx={{
                                "& .leaflet-container": {
                                    position: "relative !important",
                                },
                            }}>
                            <Box className="tw-overflow-hidden tw-rounded-xl tw-border-0 tw-bg-white tw-shadow-none dark:tw-bg-slate-900">
                            <MapContainer
                                center={{ lng: getCurrentUser?.configs?.customerSettings?.lng ?? -56.0991301, lat: getCurrentUser?.configs?.customerSettings?.lat ?? -15.5986686 }}
                                // ref={(ref) => mapRef.current = ref}
                                id="leaflet-container map-container"
                                style={{
                                    height: 350,
                                    width: "100%",
                                    transition: "all 0.5s ease-out allow-discrete",
                                }}
                                boxZoom={true}
                                zoomControl={true}
                                attributionControl
                                zoomAnimation={true}
                                zoom={15}
                            >
                                <TileLayer
                                    attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                />
                                {totalVehiclesPositions.filter((v) => v?.position?.lat !== undefined).map((v: any, index) => (
                                    <Marker
                                        key={index}
                                        position={[v.position?.lat ?? -15.5986686, v.position?.lng ?? -56.0991301]}
                                        icon={L.divIcon({
                                            className: "custom-marker",
                                            html: `<div style="
                                                    width:12px; 
                                                    height:12px;
                                                    border-radius:50%;
                                                    background: ${v.position?.speed > 0 ? "green" : "red"};
                                                    border:2px solid white;
                                                    box-shadow:0 0 4px rgba(0,0,0,0.6);
                                                "></div>`
                                        })}
                                    />
                                ))}
                                </ MapContainer>
                            </Box>
                            </Box>

                            <Box sx={{ display: 'grid', gridTemplateColumns: { xs: 'minmax(0, 1fr)', sm: 'repeat(2, minmax(0, 1fr))' }, gap: 1.5, width: '100%' }}>
                            <Box className="tw-min-w-0 tw-text-center">
                                <TotalItemCard withAdornment={true} isLoading={isLoading} title={"de Chamados Resolvidos"}>
                                <Box className="tw-relative tw-mx-auto tw-flex tw-w-fit tw-justify-center">
                                    <Box className="tw-flex tw-h-32 tw-w-32 tw-items-center tw-justify-center tw-rounded-full tw-bg-white/10 tw-ring-1 tw-ring-white/20">
                                        <Typography sx={{ fontSize: '42px', fontWeight: 600 }}>{`${totalTicketsResolved}`}</Typography>
                                    </Box>
                                    <SupportAgentOutlined className="tw-absolute -tw-right-3 tw-top-1" sx={{ height: 36, width: 36 }} />
                                </Box>
                            </TotalItemCard>
                            </Box>

                        <Box className="tw-min-w-0 tw-text-center">
                            <TotalItemCard withAdornment={true} isLoading={isLoading} title={"de Chamados Pendentes"}>
                                <Box className="tw-relative tw-mx-auto tw-flex tw-w-fit tw-justify-center">
                                    <Box className="tw-flex tw-h-32 tw-w-32 tw-items-center tw-justify-center tw-rounded-full tw-bg-white/10 tw-ring-1 tw-ring-white/20">
                                        <Typography sx={{ fontSize: '42px', fontWeight: 600 }}>{`${totalTicketsUnresolved}`}</Typography>
                                    </Box>
                                    <HailOutlined className="tw-absolute -tw-right-3 tw-top-1" sx={{ height: 36, width: 36 }} />
                                </Box>
                            </TotalItemCard>
                        </Box>
                        </Box>
                    </Box>
                    </Box>
                    {/*-----------------------*/}

                    <Box sx={chartGridSx}>
                            <Box className="tw-min-w-0 tw-text-center">
                                <TotalItemCard withAdornment={false} isLoading={isLoading} title={"de Veículos por Marca"}>
                                    <Box className="tw-flex tw-w-full tw-min-w-0 tw-justify-center">
                                        <TotalDonutChart data={totalVehiclesPerBrand.map((it: any) => it.vehicleCount)} labels={totalVehiclesPerBrand.map((it: any) => it.brandName)} type="pie" isLoading={isLoading} legendPosition="right" />
                                    </Box>
                                </TotalItemCard>
                            </Box>

                        <Box className="tw-min-w-0 tw-text-center">
                            <TotalItemCard withAdornment={false} isLoading={isLoading} title={"de Motoristas por Categoria"}>
                                <Box className="tw-flex tw-w-full tw-min-w-0 tw-justify-center">
                                    <TotalDonutChart data={totalDriversPerCnh.map((it: any) => it.driverCount)} labels={totalDriversPerCnh.map((it: any) => it.categoryName)} type="polarArea" isLoading={isLoading} legendPosition="right" />
                                </Box>
                            </TotalItemCard>
                        </Box>

                        <Box className="tw-min-w-0 tw-text-center">
                            <TotalItemCard withAdornment={false} isLoading={isLoading} title={"de Chamados por Gravidade"}>
                                <Box className="tw-flex tw-w-full tw-min-w-0 tw-justify-center">
                                    <TotalDonutChart data={totalTicketsByGravity.length > 0 ? totalTicketsByGravity.map((it: any) => it.ticketCount) : [1, 1, 1]} labels={totalTicketsByGravity.length > 0 ? totalTicketsByGravity.map((it: any) => it.gravityName) : ["Grave", "Média", "Leve"]} type="donut" isLoading={isLoading} legendPosition="right" />
                                </Box>
                            </TotalItemCard>
                        </Box>
                    </Box>
                    {/*-----------------------*/}

                    <Box sx={twoChartGridSx}>
                            <Box className="tw-min-w-0 tw-text-center">
                                <TotalItemCard withAdornment={false} isLoading={isLoading} title={"de Dispositivos por Fabricante"}>
                                    <Box className="tw-flex tw-w-full tw-min-w-0 tw-justify-center">
                                        <TotalDonutChart data={totalDevicesByManufacturer.map((it: any) => it.deviceCount)} labels={totalDevicesByManufacturer.map((it: any) => it.manufacturerName)} type="pie" isLoading={isLoading} legendPosition="right" />
                                    </Box>
                                </TotalItemCard>
                            </Box>

                        <Box className="tw-min-w-0 tw-text-center">
                            <TotalItemCard withAdornment={false} isLoading={isLoading} title={"de Veículos por Status"}>
                                <Box className="tw-flex tw-w-full tw-min-w-0 tw-justify-center">
                                    <TotalDonutChart data={totalVehiclesByStatus.map((it: any) => it.vehicleCount)} labels={totalVehiclesByStatus.map((it: any) => it.status)} type="donut" isLoading={isLoading} legendPosition="right" />
                                </Box>
                            </TotalItemCard>
                        </Box>
                    </Box>
                </Box> : <TrackingTab scope="customer" />}
            </>
        </Box>
    );
};

export default CustomerDashboard;
